import { useAuth } from "@/context/AuthContext";
import { PreviewGrid } from "@/pages/Create";
import MissionWorkspace from "@/components/MissionWorkspace";
import { isMinistry, vocab } from "@/lib/vocab";

export default function Grow() {
  const { org } = useAuth();
  const v = vocab(org);
  if (isMinistry(org)) return <MissionWorkspace />;
  const modules = [
    { title: v.growth, body: "Six health scores, your biggest bottlenecks and a 30/60/90 plan with “Do this now” buttons.", phase: "Phase 3" },
    { title: v.funding, body: "A readiness score, real gaps from your answers and an educational preparation plan — never named lenders or rates.", phase: "Phase 3" },
    { title: "AI Employees", body: "Portrait cards for the roles to hire first — and the Content Writer that drafts your weekly batch.", phase: "Phase 3" },
  ];
  return <PreviewGrid eyebrow="Grow" title="Strategy as a dashboard, not a document." body="Score rings, timelines and checklists — built from your DNA once your Launch Kit is complete." modules={modules} unlockedRoute="/home" unlockedLabel="Back to Home" />;
}
